<template>
  <div>
    <AppNavbar />
    <div class="terms-page-root">
      <div class="hero-full-bleed-row">
        <section class="privacy-hero">
          <div class="hero-content reveal">
            <p class="eyebrow">Compliance</p>
            <h1>Terms of Use</h1>
            <p class="hero-description">
              Please read these Terms carefully before using the IndieKonnect
              website and services.
            </p>
          </div>
        </section>
      </div>

      <div class="content-full-bleed-row">
        <section class="policy-section">
          <div class="policy-wrapper">
            <div class="policy-block reveal">
              <p>
                Welcome to IndieKonnect. These Terms of Use govern your access
                to and use of our website, products, services, and business
                opportunities. By using our platform, purchasing our products,
                or joining as a Brand Affiliate, you agree to these Terms.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>1. Who We Are:</h3>
              <p>
                <strong>IndieKonnect</strong> Enterprises Private Limited is a
                direct selling company registered in India. We offer lifestyle
                products, including watches, jewellery, beauty and personal care
                products, and dining accessories through our network of
                independent Brand Affiliates. Our business operates in
                accordance with the Consumer Protection Act, 2019 and the
                Consumer Protection (Direct Selling) Rules, 2021.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>2. Our Business Model:</h3>
              <p>
                IndieKonnect operates as a lawful direct selling business.
                Products are sold directly to customers through Brand Affiliates
                using offline and online channels. We are not a pyramid scheme,
                investment scheme, or get-rich-quick program. Compensation is
                earned only through genuine product sales. No earnings are
                generated simply by recruiting or enrolling new members.
              </p>
              <p>
                Any person claiming otherwise is misrepresenting IndieKonnect
                and should be reported immediately.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>3. Eligibility:</h3>
              <p>
                You must be at least 18 years old and legally capable of
                entering into a binding contract to use our platform or purchase
                products.
              </p>
              <p>
                To become a Brand Affiliate, you must complete registration,
                submit valid KYC documents including PAN and Aadhaar, sign the
                Direct Seller Agreement, and complete verification.
              </p>
              <p>
                There is no joining fee, registration fee, or enrollment charge
                to become a Brand Affiliate.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>4. Compensation and Earnings:</h3>
              <p>
                All earnings at IndieKonnect are directly linked to product
                sales.
              </p>
              <p>
                Brand Affiliates may earn through retail profit, sales
                commissions, rank advancement bonuses, reward programs such as
                IndieKonnect Coins, and other incentives offered under the
                official Compensation Plan.
              </p>
              <p>
                Any earnings shown on our platform, presentations, or
                promotional materials are illustrative only and do not guarantee
                income. Actual earnings vary based on individual effort, sales
                performance, team productivity, market conditions, and business
                activity.
              </p>
              <p>
                Before making any financial decisions, you should review our
                official Income Disclosure Statement.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>5. Acceptable Conduct:</h3>
              <p>
                When using our platform or participating as a Brand Affiliate,
                you agree to act honestly, professionally, and in compliance
                with all applicable laws.
              </p>
              <p>
                You must not make false or misleading claims about products or
                earnings, present IndieKonnect as an investment or guaranteed
                income opportunity, collect money from individuals for joining,
                misuse company branding, publish fake reviews, or engage in spam
                or unauthorized promotions. Any violation may result in
                suspension or termination of your account or affiliation.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>6. Social Media and Communication Rules:</h3>
              <p>
                Brand Affiliates promoting IndieKonnect through social media,
                messaging platforms, or online channels must clearly disclose
                that they are independent IndieKonnect Brand Affiliates.
              </p>
              <p>
                Income claims must always include the statement:
                <em
                  ><strong
                    >"Results may vary. Income is not guaranteed."</strong
                  ></em
                >
              </p>
              <p>
                You must always obtain consent before adding anyone to WhatsApp
                groups or sending promotional messages. All communications must
                comply with applicable laws, including the Information
                Technology Act, 2000 and TRAI Regulations.
              </p>
              <p>
                IndieKonnect is not affiliated with, endorsed by, or sponsored
                by WhatsApp or Meta Platforms, Inc.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>7. Products, Pricing, and Returns:</h3>
              <p>
                All product prices displayed on our platform include applicable
                GST unless stated otherwise. A valid invoice will be issued for
                every purchase. Product packaging will contain all legally
                required information, including MRP, quantity, manufacturing
                details, and manufacturer information.
              </p>
              <p>
                Brand Affiliates have a 30 working days return right from
                joining or product purchase to cancel their agreement and return
                unsold products in original condition, subject to applicable
                policies and law.
              </p>
              <p>
                Consumers may request returns, replacements, or refunds for
                products that are damaged, defective, materially different from
                description, or not delivered within the promised timeline,
                subject to our Return Policy.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>8. Privacy and Data Protection:</h3>
              <p>
                We collect and process personal information only as necessary to
                provide our services, fulfil orders, maintain compliance, and
                support business operations.
              </p>
              <p>
                Your data is handled securely and in accordance with our Privacy
                Policy. We do not sell personal data to third parties. By using
                our platform, you consent to the collection, storage, and
                processing of your information as described in our Privacy
                Policy.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>9. Grievance Redressal:</h3>
              <p>
                If you have a complaint, concern, or grievance, you may contact
                our designated Grievances Team or Nodal Officer.
              </p>
              <p>
                Nodal Officer: <strong>BHUPENDRA BHARTI</strong><br />
                Grievance Email:
                <a href="mailto:customercare@indiekonnect.com"
                  >customercare@indiekonnect.com</a
                ><br />
                Grievance Officer: <strong>Meahul Roy (Advocate)</strong>
              </p>
              <p>
                We aim to acknowledge complaints within 48 working hours and
                resolve them within 30 working days, with a maximum resolution
                period of 45 working days.
              </p>
              <p>
                You may also contact the National Consumer Helpline at
                1800-11-4000 or 14404.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>10. Independent Contractor Status:</h3>
              <p>
                Brand Affiliates operate as independent contractors and not as
                employees, agents, partners, or representatives of IndieKonnect.
                You are solely responsible for your business activities, tax
                compliance, and legal obligations arising from commissions or
                earnings. IndieKonnect may deduct TDS where required by law and
                provide relevant tax documents.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>11. Intellectual Property:</h3>
              <p>
                All rights, title, and interest in the IndieKonnect name, logo,
                trademarks, branding, website content, compensation system, and
                business materials remain the exclusive property of IndieKonnect
                Enterprises Private Limited.
              </p>
              <p>
                Brand Affiliates may use only company-approved materials for
                authorised promotional purposes. Any unauthorised use,
                reproduction, modification, or distribution is strictly
                prohibited.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>12. Limitation of Liability:</h3>
              <p>
                IndieKonnect shall not be liable for indirect, incidental,
                special, consequential, or business-related losses arising from
                use of our platform, products, or services. Our total liability
                for any claim shall not exceed the amount paid by you to
                IndieKonnect during the three months immediately preceding the
                event giving rise to the claim.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>13. Dispute Resolution and Jurisdiction:</h3>
              <p>
                These terms are governed by the laws of India. Consumer disputes
                shall be subject to the jurisdiction of courts in New Delhi
                only. Disputes involving Brand Affiliates that cannot be
                resolved amicably within 30 working days shall be referred to
                arbitration in New Delhi under the Arbitration and Conciliation
                Act, 1996.
              </p>
            </div>

            <div class="policy-block reveal">
              <h3>14. Changes to These Terms:</h3>
              <p>
                We may update these Terms from time to time to reflect legal,
                operational, or business changes.
              </p>
              <p>
                Material changes will be communicated through our website,
                email, or other official channels at least 15 working days
                before taking effect.
              </p>
              <p>
                Continued use of our platform after such updates constitutes
                acceptance of the revised Terms.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import AppNavbar from "../AppNavbar.vue";
import FooterView from "../FooterView.vue";

onMounted(() => {
  const body = document.body;
  if (body) {
    body.style.setProperty("margin", "0", "important");
    body.style.setProperty("padding", "0", "important");
    body.style.setProperty("max-width", "100%", "important");
  }

  const revealElements = document.querySelectorAll(".reveal");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    },
    { threshold: 0.08 },
  );
  revealElements.forEach((el) => observer.observe(el));
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;800&display=swap");

* {
  box-sizing: border-box;
}

.terms-page-root {
  width: 100vw !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  font-family: "Raleway", sans-serif;
  background: #f7f9fc;
  color: #333f48;
  overflow-x: hidden;
}

.hero-full-bleed-row {
  width: 100% !important;
  background: #003da5 !important;
  display: block;
}

.privacy-hero {
  width: 100% !important;
  max-width: 1240px;
  margin: 0 auto;
  padding: 30px 24px 20px;
}

.hero-content {
  width: 100%;
  max-width: 820px;
}

.eyebrow {
  color: #ffc72c;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 5px;
}

.privacy-hero h1 {
  color: white;
  font-size: 54px;
  line-height: 1;
  margin-bottom: 18px;
  font-weight: 800;
}

.hero-description {
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  line-height: 1.7;
  max-width: 650px;
}

.content-full-bleed-row {
  width: 100% !important;
  background: #f7f9fc;
  display: block;
}

.policy-section {
  width: 100% !important;
  padding: 20px 0 60px;
}

.policy-wrapper {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
}

.policy-block {
  margin-bottom: 22px;
}

.policy-block h2 {
  font-size: 34px;
  color: #003da5;
  margin-bottom: 18px;
  font-weight: 800;
}

.policy-block h3 {
  font-size: 24px;
  color: #003da5;
  margin-bottom: 14px;
  font-weight: 800;
}

.policy-block p {
  font-size: 15px;
  line-height: 1.9;
  color: #4c5661;
  margin-bottom: 14px;
}

.policy-block p a {
  color: #003da5;
  text-decoration: underline;
}

.reveal {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease;
}

.reveal.active {
  opacity: 1;
  transform: translateY(0);
}

@media (max-width: 768px) {
  .privacy-hero {
    padding: 40px 20px 20px;
  }

  .privacy-hero h1 {
    font-size: 26px;
  }

  .policy-section {
    padding: 20px 0 40px;
  }

  .policy-wrapper {
    padding: 0 20px;
  }

  .policy-block h2 {
    font-size: 28px;
  }

  .policy-block h3 {
    font-size: 21px;
  }
}
</style>
